import WebIM from '@/utils/WebIM'
const Group = {
  namespaced: true,
  state: {
    publicGroupList: [], //获取已加入的公开群群组
    dealingGroupId: '' // 当前正在窗口的groupId
  },
  mutations: {
    updatePublicGroup(state, publicGroup) {
      state.publicGroupList = publicGroup
    },
    SET_DEALING_GROUPID(state, dealingGroupId) {
      state.dealingGroupId = dealingGroupId
    }
  },
  actions: {
    //获取公开群组
    onGetPublicGroup: function (context, payload) {
      const limit = 50
      const options = {
        limit: limit, // 预期每页获取的记录数
        success: function (resp) {
          const publicGroup = resp.data
          context.commit('updatePublicGroup', publicGroup)
        },
        error: function (e) {
          console.log('获取群组失败', e, payload)
        }
      }
      WebIM.conn.listGroups(options)
    }
  },
  getters: {
    onGetPublicGroup(state) {
      return state.publicGroupList
    }
  }
}
export default Group
